import type { Locale, ThemeMode, TerritoryLevel, VisualizationType } from './types';

export const LOCALES: Locale[] = ['ru', 'en'];
export const THEME_MODES: ThemeMode[] = ['system', 'light', 'dark'];

const DICTIONARIES = {
  ru: {
    appTitle: 'Цифровая демографическая обсерватория',
    appSubtitle: 'социально-экономические показатели территорий России',
    dashboard: 'Дашборд',
    dashboardSelect: 'Выбор дашборда',
    dashboardName: 'Название',
    newDashboard: 'Новый',
    newDashboardTitle: 'Новый дашборд',
    save: 'Сохранить',
    emiss: 'ЕМИСС',
    emissSource: 'Региональная статистика',
    widgetPalette: 'Виджеты',
    widgetPaletteHint: 'Выберите тип визуализации',
    inspector: 'Настройки',
    dataMaster: 'Данные',
    styling: 'Оформление',
    source: 'Источник',
    allSources: 'Все источники',
    bdmoSource: 'Муниципальная статистика',
    worldbankSource: 'Международная статистика',
    settlements: 'Населённые пункты',
    selectWidget: 'Выберите виджет',
    selectWidgetHint: 'Нажмите на карточку в рабочей области, чтобы настроить цвета, шкалы, легенду и остальные параметры.',
    updateSelectedData: 'Обновить данные выбранного',
    addAsNew: 'Добавить как новый',
    resetAppearance: 'Сбросить оформление',
    showDataPanel: 'Показать панель данных',
    hideDataPanel: 'Скрыть панель данных',
    showWidgets: 'Показать виджеты',
    hideWidgets: 'Скрыть виджеты',
    showInspector: 'Показать настройки',
    hideInspector: 'Скрыть настройки',
    viewMode: 'Режим просмотра',
    editMode: 'Режим редактирования',
    enterViewMode: 'Открыть чистый просмотр',
    enterEditMode: 'Редактировать дашборд',
    templateBadge: 'шаблон',
    legacyTemplateBadge: 'архивный шаблон',
    myDashboards: 'Мои дашборды',
    templatesGroup: 'Шаблоны',
    legacyTemplatesGroup: 'Архивные шаблоны',
    view: 'Просмотр',
    sources: 'Источники',
    emissDiagnostics: 'Диагностика ЕМИСС',
    requestLog: 'Журнал запросов',
    properties: 'Свойства',
    widgetBuilder: 'Конструктор виджета',
    newWidget: 'Новый виджет',
    editWidget: 'Редактирование виджета',
    applyChanges: 'Применить изменения',
    addToDashboard: 'Добавить на дашборд',
    resetForm: 'Сбросить форму',
    closePanel: 'Закрыть панель',
    closeBuilderPanel: 'Закрыть панель конструктора',
    data: 'Данные',
    filters: 'Фильтры',
    help: 'Справка',
    indicatorSection: 'Раздел',
    allSections: 'Все разделы',
    indicator: 'Показатель',
    territoryLevel: 'Территориальный уровень',
    federalDistrict: 'Федеральный округ',
    federalDistricts: 'Федеральные округа',
    region: 'Субъект РФ',
    regions: 'Субъекты РФ',
    municipalities: 'Муниципалитеты',
    allDistricts: 'Все округа',
    allRegions: 'Все субъекты',
    territorySearch: 'Поиск населённого пункта',
    territories: 'Территории',
    selectAll: 'Выбрать все',
    selectVisible: 'Выбрать видимые',
    clearSelection: 'Снять выбор',
    years: 'Годы',
    months: 'Месяцы',
    monthsEmptyMeansAll: 'Пустой выбор означает все доступные месяцы.',
    presentation: 'Представление',
    visualizationType: 'Тип визуализации',
    widgetTitle: 'Заголовок виджета',
    autoTitle: 'Будет сформирован автоматически',
    palette: 'Палитра',
    dashboardPalette: 'Цвета дашборда',
    decimals: 'Знаков после запятой',
    showLegend: 'Показывать легенду',
    showLabels: 'Подписи значений',
    reversePalette: 'Обратить палитру',
    advancedSettings: 'Расширенные настройки',
    orientation: 'Ориентация',
    auto: 'Авто',
    horizontal: 'Горизонтальная',
    vertical: 'Вертикальная',
    sorting: 'Сортировка',
    sortDesc: 'По убыванию',
    sortAsc: 'По возрастанию',
    sourceOrder: 'Исходный порядок',
    topNHelp: '0 — показывать все значения.',
    axisScale: 'Шкала оси',
    linear: 'Линейная',
    logarithmic: 'Логарифмическая',
    zeroLine: 'Нулевая линия',
    alwaysIncludeZero: 'Всегда включать ноль',
    neverForceZero: 'Не принуждать к нулю',
    dataZoom: 'Масштабирование',
    always: 'Всегда',
    disabled: 'Отключить',
    pointMarkers: 'Маркеры точек',
    show: 'Показывать',
    hide: 'Скрыть',
    legendPosition: 'Положение легенды',
    top: 'Сверху',
    bottom: 'Снизу',
    right: 'Справа',
    smoothLines: 'Сглаживать линии',
    duplicateColorsWithPatterns: 'Дублировать цвета узорами',
    mapSettings: 'Классификация и время карты',
    periodDisplay: 'Период отображения',
    method: 'Метод',
    quantile: 'Квантили',
    equalIntervals: 'Равные интервалы',
    jenks: 'Естественные границы Jenks',
    manual: 'Ручные границы',
    classCount: 'Число классов',
    classBreaks: 'Границы классов',
    classBreaksPlaceholder: 'Например: 5; 10; 15; 20',
    timeScaleComparable: 'Сопоставимость шкалы во времени',
    globalScale: 'Единая для всех выбранных периодов',
    currentScale: 'Пересчитывать для текущего периода',
    fixedScale: 'Фиксированный диапазон',
    mapScaleHelp: 'Единая шкала позволяет корректно сравнивать цвета между годами.',
    mapBasemap: 'Подложка карты',
    mapBasemapAuto: 'Авто: светлая / тёмная карта',
    mapBasemapBlankLight: 'Светлая карта',
    mapBasemapBlankDark: 'Тёмная карта',
    mapBasemapOsm: 'OpenStreetMap',
    mapBasemapSatellite: 'Спутник',
    scaleMinimum: 'Минимум шкалы',
    scaleMaximum: 'Максимум шкалы',
    missingColor: 'Цвет пропусков',
    showPeriodSelector: 'Показывать селектор периода в виджете',
    conditionalFormatting: 'Условное оформление',
    condition: 'Условие',
    noCondition: 'Не применять',
    greaterThan: 'Больше',
    greaterOrEqual: 'Больше или равно',
    lessThan: 'Меньше',
    lessOrEqual: 'Меньше или равно',
    threshold: 'Порог',
    color: 'Цвет',
    sourcesSeparatedTitle: 'Данные готовы к визуализации.',
    sourcesSeparatedText: 'Выберите показатель, территорию и виджет — дашборд загрузит доступные наблюдения и покажет результат.',
    workspace: 'Рабочая область',
    layoutHelp: 'Собирайте дашборд из виджетов, переставляйте их на холсте и сохраняйте результат.',
    mobileLayoutHelp: 'Мобильный режим: виджеты идут одной колонкой, а данные добавляются через панель «Мастер».',
    addWidget: '＋ Виджет',
    hidePanel: 'Скрыть панель',
    finishLayout: 'Завершить компоновку',
    editLayout: 'Редактировать макет',
    compactLayout: 'Уплотнить',
    compactLayoutTitle: 'Убрать пустые промежутки между виджетами',
    notSaved: 'Не сохранён',
    dashboardFilters: 'Фильтры дашборда',
    year: 'Год',
    territory: 'Территория',
    reset: 'Сбросить',
    emptyDashboard: 'Пустой дашборд',
    emptyDashboardHint: 'Выберите показатель, территории и тип визуализации, затем добавьте первый виджет.',
    addFirstWidget: 'Добавить виджет',
    openDashboards: 'Дашборды',
    runAutoBuilder: 'Автоконструктор',
    dashboardManagerTitle: 'Сохранённые дашборды',
    dashboardManagerSearchPlaceholder: 'Поиск по названию',
    noDashboardsFound: 'Ничего не найдено',
    noDashboardsFoundHint: 'Измените поисковый запрос или создайте новый дашборд.',
    dashboardSections: 'Разделы дашбордов',
    dashboardsTabMine: 'Мои',
    dashboardsTabDemo: 'Общие',
    dashboardsTabAll: 'Все',
    demoDashboardsHint: 'Общие дашборды и шаблоны видны всем. Если у вас нет права их изменять, скопируйте дашборд к себе.',
    noDemoDashboards: 'Общих дашбордов нет',
    demoReadOnlyStatus: 'Общий дашборд открыт только для просмотра: сохранение создаст вашу копию.',
    dashboardOpened: 'открыт',
    addFavorite: 'Добавить в избранное',
    removeFavorite: 'Убрать из избранного',
    favoriteAdded: 'Дашборд добавлен в избранное',
    favoriteRemoved: 'Дашборд убран из избранного',
    copyDashboard: 'Копировать',
    renameDashboard: 'Переименовать',
    deleteDashboard: 'Удалить',
    confirmDelete: 'Удалить',
    cancelDelete: 'Отмена',
    confirmDeleteHint: 'Подтвердите удаление в строке дашборда или нажмите «Отмена».',
    copyOpenedStatus: 'Открыта копия «{name}». Оригинал не изменён.',
    autoBuilderTitle: 'Автоконструктор дашборда',
    autoBuilderDescription: 'Выберите источник и раздел: платформа соберёт новую витрину из разных показателей и визуализаций.',
    autoBuilderLoading: 'Загружаю разделы, территории и годы...',
    autoBuilderReady: 'Готов к созданию новой витрины.',
    autoBuilderSafeDefault: 'Пустой выбор территорий и годов означает безопасный автоматический охват.',
    autoBuilderPreview: 'План: {indicators} показателей-кандидатов, {territories} территорий, {years} лет; будет создано до {widgets} виджетов.',
    autoBuilderAutoPick: 'Автоподбор',
    autoBuilderAutoFill: 'Автодобор',
    autoBuilderIndicators: 'Показатели',
    autoBuilderIndicatorsHint: 'Если ничего не отмечено, автоконструктор сам подберёт разные показатели из раздела.',
    autoBuilderSectionSearch: 'Поиск раздела',
    autoBuilderIndicatorSearch: 'Поиск показателя по названию или ID',
    autoBuilderTerritorySearch: 'Поиск территории',
    autoBuilderYearSearch: 'Поиск года',
    autoBuilderDistricts: 'Федеральные округа',
    autoBuilderRegions: 'Субъекты РФ',
    autoBuilderMunicipalities: 'Муниципалитеты',
    autoBuilderDistrictSearch: 'Поиск округа',
    autoBuilderRegionSearch: 'Поиск субъекта',
    autoBuilderMunicipalitySearch: 'Поиск муниципалитета',
    autoBuilderAutoChoice: 'Автовыбор',
    autoBuilderSelectedCount: 'Выбрано: {selected} из {total}',
    autoBuilderVisibleCount: 'Показано: {visible} из {total}',
    autoBuilderPreliminaryYears: 'Предварительный диапазон: точные годы уточнятся при подключении показателя.',
    autoBuilderBdmoTerritoryHint: 'Пустой выбор на уровне означает “не ограничивать”; муниципалитеты фильтруются выбранными округами и субъектами.',
    autoBuilderColorHint: 'Единый цвет витрины',
    resetColor: 'Сбросить',
    createDashboard: 'Создать дашборд',
    cancel: 'Отмена',
    globalFiltersHint: 'Фильтры применяются ко всем виджетам без повторной загрузки данных.',
    initialization: 'Инициализация…',
    gridColumns: 'Макет: {count} колонок',
    loadingCatalogs: 'Загрузка каталогов…',
    catalogsLoaded: 'Каталоги загружены. Создайте первый дашборд.',
    noApi: 'Нет связи с API',
    backendPortHint: 'Проверьте, что приложение запущено на http://127.0.0.1:8080.',
    unsavedDashboard: '— несохранённый дашборд —',
    saved: 'Сохранено',
    unsaved: 'Есть несохранённые изменения',
    unnamed: 'Без названия',
    allYears: 'Все выбранные годы',
    allTerritories: 'Все выбранные территории',
    selectedOf: 'Выбрано: {selected} из {visible}',
    loading: 'Загрузка…',
    loadingMunicipalities: 'Загрузка муниципалитетов…',
    loadingTerritoryCatalog: 'Загрузка территориального каталога…',
    loadingEmissTerritories: 'Загрузка территорий ЕМИСС…',
    loadingSettlements: 'Загрузка населённых пунктов…',
    recommendationPending: 'Рекомендация формируется',
    recommendationPendingHint: 'Выберите показатель, территории и периоды.',
    apply: 'Применить',
    analyticsDimensions: 'Аналитические разрезы',
    dimensionsHint: 'Итоговые категории выбраны автоматически; изменяйте их только осознанно.',
    dimensionDefault: 'Итог по умолчанию',
    selectedNone: 'не выбрано',
    selectedShort: '{count} знач.',
    selectedValues: 'Выбрано значений: {selected} из {total}.',
    noDataForSelection: 'Для выбранного фильтра и периода нет данных.',
    preparing: 'Подготовка…',
    previousPeriod: 'Предыдущий период',
    nextPeriod: 'Следующий период',
    refreshData: 'Обновить данные',
    duplicate: 'Дублировать',
    widgetActions: 'Действия виджета',
    layoutCommands: 'Команды расположения',
    edit: 'Редактировать',
    delete: 'Удалить',
    position: 'Положение',
    sizeByGrid: 'Размер по сетке',
    narrower: 'Уже',
    wider: 'Шире',
    shorter: 'Ниже',
    taller: 'Выше',
    localDataset: 'локальный набор',
    cache: 'кэш',
    hitAfterWait: 'кэш после ожидания',
    fetchedFromEmiss: 'загружено из ЕМИСС',
    parquetQuery: 'запрос к Parquet',
    staleCache: 'устаревший кэш',
    observationOne: 'наблюдение',
    observationFew: 'наблюдения',
    observationMany: 'наблюдений',
    qualityPassed: 'контроль качества: пройден',
    qualityIssues: 'контроль качества: {count} замеч.',
    settings: 'Настройки',
    language: 'Язык',
    currentLanguage: 'Язык: русский',
    theme: 'Тема',
    system: 'Система',
    light: 'Светлая',
    dark: 'Тёмная',
    primaryColor: 'Основной цвет',
    baseColor: 'Основной',
    contrastColor: 'Контрастный',
    presets: 'Пресеты',
    resetColors: 'Сброс',
    colorWarning: 'Цвета слишком близки: интерфейс останется рабочим, но контраст будет слабее.',
    emissCatalog: 'Каталог показателей fedstat.ru',
    remoteSource: 'Удалённый источник',
    emissManagerTitle: 'Менеджер ЕМИСС / fedstat.ru',
    emissManagerDescription: 'Проверка метаданных, настройка фильтров и регистрация показателя без предварительной выгрузки всей базы.',
    closeEmissManager: 'Закрыть менеджер ЕМИСС',
    checkingConfiguration: 'Проверка конфигурации…',
    catalogNotLoaded: 'Каталог ещё не загружен.',
    refreshCatalog: 'Обновить каталог',
    indicatorSearch: 'Поиск показателя по названию или ID',
    indicatorSearchPlaceholder: 'Например: рождаемость или 62852',
    find: 'Найти',
    includeExcluded: 'Показать скрытые/исключённые',
    registered: 'уже зарегистрирован',
    inspectIndicator: 'Исследовать показатель',
    register: 'Зарегистрировать',
    checkAccess: 'Проверить доступ',
    latestRequests: 'Последние обращения',
    emissIndicatorId: 'ID показателя ЕМИСС',
    emissIndicatorPlaceholder: 'Например, 31517',
    localId: 'Локальный ID',
    localIdPlaceholder: 'Сформируется автоматически',
    catalogName: 'Название в каталоге',
    catalogNamePlaceholder: 'Будет взято из ЕМИСС',
    unit: 'Единица измерения',
    unitDefault: 'ед.',
    forceRefreshMetadata: 'Обновить метаданные принудительно',
    activateAfterCheck: 'Активировать после проверки',
    overwriteRegistration: 'Перезаписать существующую регистрацию',
    emissInitialMessage: 'Введите ID показателя и выполните исследование метаданных.',
    refreshLog: 'Обновить журнал',
    logNotLoaded: 'Журнал ещё не загружен.',
    networkRouteTitle: 'Сетевой маршрут не хранится в дашборде.',
    networkRouteText: 'Приложение не хранит сетевые параметры и не поднимает туннелей: при работе через прокси бэкенду передаётся только его адрес, ключевой материал остаётся вне репозитория.',
  },
  en: {
    appTitle: 'Digital Demographic Observatory',
    appSubtitle: 'socio-economic indicators for Russian territories',
    dashboard: 'Dashboard',
    dashboardSelect: 'Dashboard selector',
    dashboardName: 'Name',
    newDashboard: 'New',
    newDashboardTitle: 'New dashboard',
    save: 'Save',
    emiss: 'EMISS',
    emissSource: 'Regional statistics',
    widgetPalette: 'Widgets',
    widgetPaletteHint: 'Choose a visualization type',
    inspector: 'Inspector',
    dataMaster: 'Data',
    styling: 'Style',
    source: 'Source',
    allSources: 'All sources',
    bdmoSource: 'Municipal statistics',
    worldbankSource: 'International statistics',
    settlements: 'Settlements',
    selectWidget: 'Select a widget',
    selectWidgetHint: 'Click a card in the workspace to adjust colors, scales, legend and other visual settings.',
    updateSelectedData: 'Update selected data',
    addAsNew: 'Add as new',
    resetAppearance: 'Reset style',
    showDataPanel: 'Show data panel',
    hideDataPanel: 'Hide data panel',
    showWidgets: 'Show widgets',
    hideWidgets: 'Hide widgets',
    showInspector: 'Show inspector',
    hideInspector: 'Hide inspector',
    viewMode: 'View mode',
    editMode: 'Edit mode',
    enterViewMode: 'Open clean view',
    enterEditMode: 'Edit dashboard',
    templateBadge: 'template',
    legacyTemplateBadge: 'legacy template',
    myDashboards: 'My dashboards',
    templatesGroup: 'Templates',
    legacyTemplatesGroup: 'Legacy templates',
    view: 'View',
    sources: 'Sources',
    emissDiagnostics: 'EMISS diagnostics',
    requestLog: 'Request log',
    properties: 'Properties',
    widgetBuilder: 'Widget builder',
    newWidget: 'New widget',
    editWidget: 'Edit widget',
    applyChanges: 'Apply changes',
    addToDashboard: 'Add to dashboard',
    resetForm: 'Reset form',
    closePanel: 'Close panel',
    closeBuilderPanel: 'Close widget builder',
    data: 'Data',
    filters: 'Filters',
    help: 'Help',
    indicatorSection: 'Section',
    allSections: 'All sections',
    indicator: 'Indicator',
    territoryLevel: 'Territory level',
    federalDistrict: 'Federal district',
    federalDistricts: 'Federal districts',
    region: 'Region',
    regions: 'Regions',
    municipalities: 'Municipalities',
    allDistricts: 'All districts',
    allRegions: 'All regions',
    territorySearch: 'Settlement search',
    territories: 'Territories',
    selectAll: 'Select all',
    selectVisible: 'Select visible',
    clearSelection: 'Clear selection',
    years: 'Years',
    months: 'Months',
    monthsEmptyMeansAll: 'Empty selection means all available months.',
    presentation: 'View',
    visualizationType: 'Visualization type',
    widgetTitle: 'Widget title',
    autoTitle: 'Generated automatically',
    palette: 'Palette',
    dashboardPalette: 'Dashboard colors',
    decimals: 'Decimal places',
    showLegend: 'Show legend',
    showLabels: 'Value labels',
    reversePalette: 'Reverse palette',
    advancedSettings: 'Advanced settings',
    orientation: 'Orientation',
    auto: 'Auto',
    horizontal: 'Horizontal',
    vertical: 'Vertical',
    sorting: 'Sorting',
    sortDesc: 'Descending',
    sortAsc: 'Ascending',
    sourceOrder: 'Source order',
    topNHelp: '0 means show all values.',
    axisScale: 'Axis scale',
    linear: 'Linear',
    logarithmic: 'Logarithmic',
    zeroLine: 'Zero line',
    alwaysIncludeZero: 'Always include zero',
    neverForceZero: 'Do not force zero',
    dataZoom: 'Zoom',
    always: 'Always',
    disabled: 'Disabled',
    pointMarkers: 'Point markers',
    show: 'Show',
    hide: 'Hide',
    legendPosition: 'Legend position',
    top: 'Top',
    bottom: 'Bottom',
    right: 'Right',
    smoothLines: 'Smooth lines',
    duplicateColorsWithPatterns: 'Duplicate colors with patterns',
    mapSettings: 'Map classification and time',
    periodDisplay: 'Display period',
    method: 'Method',
    quantile: 'Quantiles',
    equalIntervals: 'Equal intervals',
    jenks: 'Jenks natural breaks',
    manual: 'Manual breaks',
    classCount: 'Class count',
    classBreaks: 'Class breaks',
    classBreaksPlaceholder: 'For example: 5; 10; 15; 20',
    timeScaleComparable: 'Comparable scale over time',
    globalScale: 'One scale for all selected periods',
    currentScale: 'Recalculate for current period',
    fixedScale: 'Fixed range',
    mapScaleHelp: 'A single scale makes colors comparable between years.',
    mapBasemap: 'Map basemap',
    mapBasemapAuto: 'Auto: light / dark map',
    mapBasemapBlankLight: 'Light map',
    mapBasemapBlankDark: 'Dark map',
    mapBasemapOsm: 'OpenStreetMap',
    mapBasemapSatellite: 'Satellite',
    scaleMinimum: 'Scale minimum',
    scaleMaximum: 'Scale maximum',
    missingColor: 'Missing value color',
    showPeriodSelector: 'Show period selector in widget',
    conditionalFormatting: 'Conditional styling',
    condition: 'Condition',
    noCondition: 'Do not apply',
    greaterThan: 'Greater than',
    greaterOrEqual: 'Greater than or equal',
    lessThan: 'Less than',
    lessOrEqual: 'Less than or equal',
    threshold: 'Threshold',
    color: 'Color',
    sourcesSeparatedTitle: 'Data is ready to visualize.',
    sourcesSeparatedText: 'Choose an indicator, territory and widget. The dashboard will load the available observations and show the result.',
    workspace: 'Workspace',
    layoutHelp: 'Build the dashboard from widgets, arrange them on the canvas and save the result.',
    mobileLayoutHelp: 'Mobile mode: widgets stack in one column, and data is added through the Wizard panel.',
    addWidget: '+ Widget',
    hidePanel: 'Hide panel',
    finishLayout: 'Finish layout',
    editLayout: 'Edit layout',
    compactLayout: 'Compact',
    compactLayoutTitle: 'Remove empty gaps between widgets',
    notSaved: 'Not saved',
    dashboardFilters: 'Dashboard filters',
    year: 'Year',
    territory: 'Territory',
    reset: 'Reset',
    emptyDashboard: 'Empty dashboard',
    emptyDashboardHint: 'Choose an indicator, territories and visualization type, then add the first widget.',
    addFirstWidget: 'Add widget',
    openDashboards: 'Dashboards',
    runAutoBuilder: 'Autobuilder',
    dashboardManagerTitle: 'Saved dashboards',
    dashboardManagerSearchPlaceholder: 'Search by title',
    noDashboardsFound: 'Nothing found',
    noDashboardsFoundHint: 'Change the search query or create a new dashboard.',
    dashboardSections: 'Dashboard sections',
    dashboardsTabMine: 'Mine',
    dashboardsTabDemo: 'Shared',
    dashboardsTabAll: 'All',
    demoDashboardsHint: 'Shared dashboards and templates are visible to everyone. If you cannot edit one, copy it to your own.',
    noDemoDashboards: 'No shared dashboards',
    demoReadOnlyStatus: 'Shared dashboard is read-only: saving creates your own copy.',
    dashboardOpened: 'open',
    addFavorite: 'Add to favorites',
    removeFavorite: 'Remove from favorites',
    favoriteAdded: 'Dashboard added to favorites',
    favoriteRemoved: 'Dashboard removed from favorites',
    copyDashboard: 'Copy',
    renameDashboard: 'Rename',
    deleteDashboard: 'Delete',
    confirmDelete: 'Delete',
    cancelDelete: 'Cancel',
    confirmDeleteHint: 'Confirm deletion in the dashboard row or choose Cancel.',
    copyOpenedStatus: 'Opened copy "{name}". The original was not changed.',
    autoBuilderTitle: 'Dashboard autobuilder',
    autoBuilderDescription: 'Choose a source and section: the platform will assemble a new showcase from different indicators and visualizations.',
    autoBuilderLoading: 'Loading sections, territories and years...',
    autoBuilderReady: 'Ready to create a new showcase.',
    autoBuilderSafeDefault: 'Empty territory and year selections mean safe automatic coverage.',
    autoBuilderPreview: 'Plan: {indicators} candidate indicators, {territories} territories, {years} years; up to {widgets} widgets will be created.',
    autoBuilderAutoPick: 'Auto-pick',
    autoBuilderAutoFill: 'Auto-fill gaps',
    autoBuilderIndicators: 'Indicators',
    autoBuilderIndicatorsHint: 'If nothing is checked, the autobuilder will choose a varied set from the section.',
    autoBuilderSectionSearch: 'Search sections',
    autoBuilderIndicatorSearch: 'Search indicator by title or ID',
    autoBuilderTerritorySearch: 'Search territory',
    autoBuilderYearSearch: 'Search year',
    autoBuilderDistricts: 'Federal districts',
    autoBuilderRegions: 'Regions',
    autoBuilderMunicipalities: 'Municipalities',
    autoBuilderDistrictSearch: 'Search district',
    autoBuilderRegionSearch: 'Search region',
    autoBuilderMunicipalitySearch: 'Search municipality',
    autoBuilderAutoChoice: 'Auto selection',
    autoBuilderSelectedCount: 'Selected: {selected} of {total}',
    autoBuilderVisibleCount: 'Shown: {visible} of {total}',
    autoBuilderPreliminaryYears: 'Preliminary range: exact years will be refined when the indicator is connected.',
    autoBuilderBdmoTerritoryHint: 'Empty choice on a level means “do not restrict”; municipalities are filtered by selected districts and regions.',
    autoBuilderColorHint: 'Unified showcase color',
    resetColor: 'Reset',
    createDashboard: 'Create dashboard',
    cancel: 'Cancel',
    globalFiltersHint: 'Filters apply to all widgets without reloading data.',
    initialization: 'Initializing…',
    gridColumns: 'Layout: {count} columns',
    loadingCatalogs: 'Loading catalogs…',
    catalogsLoaded: 'Catalogs loaded. Create the first dashboard.',
    noApi: 'No API connection',
    backendPortHint: 'Check that the app is running at http://127.0.0.1:8080.',
    unsavedDashboard: '— unsaved dashboard —',
    saved: 'Saved',
    unsaved: 'Unsaved changes',
    unnamed: 'Untitled',
    allYears: 'All selected years',
    allTerritories: 'All selected territories',
    selectedOf: 'Selected: {selected} of {visible}',
    loading: 'Loading…',
    loadingMunicipalities: 'Loading municipalities…',
    loadingTerritoryCatalog: 'Loading territory catalog…',
    loadingEmissTerritories: 'Loading EMISS territories…',
    loadingSettlements: 'Loading settlements…',
    recommendationPending: 'Recommendation is forming',
    recommendationPendingHint: 'Choose an indicator, territories and periods.',
    apply: 'Apply',
    analyticsDimensions: 'Analytical dimensions',
    dimensionsHint: 'Total categories are selected automatically; change them deliberately.',
    dimensionDefault: 'Default total',
    selectedNone: 'none selected',
    selectedShort: '{count} vals.',
    selectedValues: 'Selected values: {selected} of {total}.',
    noDataForSelection: 'No data for the selected filter and period.',
    preparing: 'Preparing…',
    previousPeriod: 'Previous period',
    nextPeriod: 'Next period',
    refreshData: 'Refresh data',
    duplicate: 'Duplicate',
    widgetActions: 'Widget actions',
    layoutCommands: 'Layout commands',
    edit: 'Edit',
    delete: 'Delete',
    position: 'Position',
    sizeByGrid: 'Grid size',
    narrower: 'Narrower',
    wider: 'Wider',
    shorter: 'Shorter',
    taller: 'Taller',
    localDataset: 'local dataset',
    cache: 'cache',
    hitAfterWait: 'cache after wait',
    fetchedFromEmiss: 'loaded from EMISS',
    parquetQuery: 'Parquet query',
    staleCache: 'stale cache',
    observationOne: 'observation',
    observationFew: 'observations',
    observationMany: 'observations',
    qualityPassed: 'quality check: passed',
    qualityIssues: 'quality check: {count} issues',
    settings: 'Settings',
    language: 'Language',
    currentLanguage: 'Language: English',
    theme: 'Theme',
    system: 'System',
    light: 'Light',
    dark: 'Dark',
    primaryColor: 'Primary color',
    baseColor: 'Primary',
    contrastColor: 'Contrast',
    presets: 'Presets',
    resetColors: 'Reset',
    colorWarning: 'The colors are very close: the interface remains usable, but contrast is weaker.',
    emissCatalog: 'fedstat.ru indicator catalog',
    remoteSource: 'Remote source',
    emissManagerTitle: 'EMISS / fedstat.ru Manager',
    emissManagerDescription: 'Check metadata, configure filters and register an indicator without downloading the whole source database first.',
    closeEmissManager: 'Close EMISS manager',
    checkingConfiguration: 'Checking configuration…',
    catalogNotLoaded: 'Catalog is not loaded yet.',
    refreshCatalog: 'Refresh catalog',
    indicatorSearch: 'Search indicator by title or ID',
    indicatorSearchPlaceholder: 'For example: fertility or 62852',
    find: 'Find',
    includeExcluded: 'Show hidden/excluded',
    registered: 'already registered',
    inspectIndicator: 'Inspect indicator',
    register: 'Register',
    checkAccess: 'Check access',
    latestRequests: 'Latest requests',
    emissIndicatorId: 'EMISS indicator ID',
    emissIndicatorPlaceholder: 'For example, 31517',
    localId: 'Local ID',
    localIdPlaceholder: 'Generated automatically',
    catalogName: 'Catalog name',
    catalogNamePlaceholder: 'Loaded from EMISS',
    unit: 'Unit',
    unitDefault: 'unit',
    forceRefreshMetadata: 'Force metadata refresh',
    activateAfterCheck: 'Activate after check',
    overwriteRegistration: 'Overwrite existing registration',
    emissInitialMessage: 'Enter an indicator ID and inspect its metadata.',
    refreshLog: 'Refresh log',
    logNotLoaded: 'The log is not loaded yet.',
    networkRouteTitle: 'The network route is not stored in the dashboard.',
    networkRouteText: 'The app stores no network parameters and opens no tunnels: when a proxy is used, the backend receives only its address, and key material stays outside the repository.',
  },
} as const;

export type I18nKey = keyof typeof DICTIONARIES.ru;

/** Пары «русская строка → английская» из словаря ключей — для перевода разметки по тексту (ui-i18n.ts). */
export function dictionaryPairs(): Array<[string, string]> {
  const pairs: Array<[string, string]> = [];
  (Object.keys(DICTIONARIES.ru) as I18nKey[]).forEach((key) => {
    pairs.push([DICTIONARIES.ru[key], DICTIONARIES.en[key]]);
  });
  (Object.keys(VISUALIZATION_LABELS.ru) as VisualizationType[]).forEach((key) => {
    pairs.push([VISUALIZATION_LABELS.ru[key], VISUALIZATION_LABELS.en[key]]);
  });
  (Object.keys(LEVEL_LABELS.ru) as TerritoryLevel[]).forEach((key) => {
    pairs.push([LEVEL_LABELS.ru[key], LEVEL_LABELS.en[key]]);
  });
  MONTH_LABELS.ru.forEach((label, index) => pairs.push([label, MONTH_LABELS.en[index] ?? label]));
  return pairs;
}

export function normalizeLocale(value: string | null | undefined): Locale {
  return value === 'en' || value === 'ru' ? value : 'ru';
}

export function resolveSystemLocale(language = navigator.language): Locale {
  return language.toLocaleLowerCase().startsWith('en') ? 'en' : 'ru';
}

export function t(locale: Locale, key: I18nKey, values: Record<string, string | number> = {}): string {
  let text: string = DICTIONARIES[locale][key] ?? DICTIONARIES.ru[key] ?? key;
  Object.entries(values).forEach(([name, value]) => {
    text = text.replaceAll(`{${name}}`, String(value));
  });
  return text;
}

export function localeTag(locale: Locale): string {
  return locale === 'en' ? 'en-US' : 'ru-RU';
}

export function formatNumber(value: number | null | undefined, locale: Locale, decimals = 1): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return new Intl.NumberFormat(localeTag(locale), {
    minimumFractionDigits: 0,
    maximumFractionDigits: Math.max(0, Math.min(6, decimals)),
  }).format(value);
}

export function formatDateTime(value: string | Date | null | undefined, locale: Locale): string {
  if (!value) return '—';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(localeTag(locale), {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date);
}

export function collator(locale: Locale): Intl.Collator {
  return new Intl.Collator(localeTag(locale), { numeric: true, sensitivity: 'base' });
}

export const VISUALIZATION_LABELS: Record<Locale, Record<VisualizationType, string>> = {
  ru: {
    kpi: 'KPI-карточка',
    line: 'Линейный график',
    bar: 'Столбчатая диаграмма',
    area: 'Диаграмма с заполнением',
    normalized_bar: 'Нормированная диаграмма, 100%',
    heatmap: 'Тепловая матрица',
    scatter: 'Диаграмма рассеяния',
    pie: 'Круговая диаграмма',
    histogram: 'Гистограмма распределения',
    population_pyramid: 'Половозрастная пирамида',
    network: 'Сетевой граф',
    flow: 'Граф потоков',
    flow_map: 'Карта потоков',
    small_multiples_bar: 'Серия столбчатых диаграмм',
    district_mini_maps: 'Мини-карты округов',
    table: 'Таблица',
    choropleth: 'Картограмма',
    map_symbols: 'Картодиаграмма',
  },
  en: {
    kpi: 'KPI card',
    line: 'Line chart',
    bar: 'Bar chart',
    area: 'Area chart',
    normalized_bar: '100% stacked chart',
    heatmap: 'Heatmap',
    scatter: 'Scatter plot',
    pie: 'Pie chart',
    histogram: 'Histogram',
    population_pyramid: 'Population pyramid',
    network: 'Network graph',
    flow: 'Flow graph',
    flow_map: 'Flow map',
    small_multiples_bar: 'Small multiples bars',
    district_mini_maps: 'District mini maps',
    table: 'Table',
    choropleth: 'Choropleth',
    map_symbols: 'Symbol map',
  },
};

export const LEVEL_LABELS: Record<Locale, Record<TerritoryLevel, string>> = {
  ru: {
    country: 'Российская Федерация',
    federal_district: 'Федеральный округ',
    region: 'Субъект Российской Федерации',
    municipality: 'Муниципалитеты',
    municipality_upper: 'Муниципалитеты',
    municipality_lower: 'Поселения',
    settlement: 'Населённый пункт',
  },
  en: {
    country: 'Russian Federation',
    federal_district: 'Federal district',
    region: 'Region',
    municipality: 'Municipality',
    municipality_upper: 'Upper-level municipality',
    municipality_lower: 'Lower-level municipality',
    settlement: 'Settlement',
  },
};

export const MONTH_LABELS: Record<Locale, string[]> = {
  ru: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ],
  en: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
};
